/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import { AppBar, Toolbar, Grid, makeStyles, IconButton } from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import "./PrimaryNavigation.scss";

const useStyles = makeStyles((_theme) => ({
	logo: {
		margin: "-1px 10px 0 0",
		height: 43,
	},
	grow: {
		flexGrow: 1,
	},
	role: {
		fontSize: 12,
		textAlign: "right",
		fontWeight: "bold",
		margin: "4px 0 3px 0",
		paddingTop: 3,
	},
	email: {
		fontSize: 12,
		fontWeight: "light",
		textAlign: "right",
		padding: 0,
	},
	toolbar: {
		height: "100%",
		backgroundColor: "white !important",
	},
	appBar: {
		zIndex: 199,
		height: 64,
		backgroundColor: "#FFF",
	},
}));

const PrimaryNavigation = ({ signOut, userInfo }) => {
	const classes = useStyles();
	return (
		<AppBar position="fixed" className={classes.appBar}>
			<Toolbar classes={{ root: classes.toolbar }}>
				<Grid container direction="row" justifyContent="space-between" alignContent="center" alignItems="center">
					<Grid item>
						<Grid container direction="row" alignItems="center" alignContent="center">
							<Grid item>
								<img
									alt="PACE Logo"
									className={classes.logo}
									src={process.env.PUBLIC_URL + "/images/pace_header_logo.png"}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item style={{ color: "black" }}>
						<Grid container direction="row" alignItems="center">
							<Grid item>
								<div className={classes.email}>{userInfo.email}</div>
							</Grid>
							<Grid item>
								<IconButton color="inherit" onClick={signOut}>
									<ExitToApp />
								</IconButton>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
	);
};

PrimaryNavigation.propTypes = {
	signOut: PropTypes.func.isRequired,
};

export default PrimaryNavigation;
